import { create } from 'zustand'

interface UnsavedChangesStore {
  registrations: Set<string>
  register: (id: string) => void
  unregister: (id: string) => void
  isDirty: () => boolean
}

export const useUnsavedChangesStore = create<UnsavedChangesStore>((set, get) => ({
  registrations: new Set(),

  register: (id: string) => set(state => ({ registrations: new Set(state.registrations).add(id) })),

  unregister: (id: string) =>
    set(state => {
      const next = new Set(state.registrations)
      next.delete(id)
      return { registrations: next }
    }),

  isDirty: () => get().registrations.size > 0
}))
